import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SalesHome from './SalesHome';
import Splitter from './Splitter';
import Funnel from './Funnel';
import ChurchFunnel from './ChurchFunnel';
import PeronyxHome from './PeronyxHome';
import FreeReview from './FreeReview';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"      element={<SalesHome />} />
        <Route path="/start" element={<Splitter />} />
        <Route path="/home"  element={<PeronyxHome />} />
        <Route path="/business"  element={<Funnel />} />
        <Route path="/ministry"  element={<ChurchFunnel />} />
        <Route path="/review" element={<FreeReview />} />
      </Routes>
    </BrowserRouter>
  );
}
